import { render, staticRenderFns } from "./SelectDeliveryArea.vue?vue&type=template&id=79a36290&scoped=true&"
import script from "./SelectDeliveryArea.vue?vue&type=script&lang=js&"
export * from "./SelectDeliveryArea.vue?vue&type=script&lang=js&"
import style0 from "./SelectDeliveryArea.vue?vue&type=style&index=0&id=79a36290&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a36290",
  null
  
)

export default component.exports